module.exports = __webpack_public_path__ + "static/ilutracao-precificacao-5953a86fcbe017513b4a624f5055d00b.svg";